<template>
    <div
        v-if="visible"
        class="globalSearch"
        ref="searchBox"
        :style="computedPosition"
    >
        <!-- IE 2026 09 23 / ODOO-341407: i18n — all UI strings of the search / history / job / log form; Russian strings replaced by English keys -->
        <div class="search-comment" v-if="command === 'globalJob'">
            <div
                ref="comment"
                class="job-comment"
                contenteditable="true"
            />
            <button class="p-link p-2" @click="newJob" v-wjTooltip="t('Ask Job')">
                <i class="pi pi-arrow-up"></i>
            </button>          
        </div>

        <div class="widget-loading-border" v-if="isLoading" />

        <!-- ODOO-4334: второй вид поиска — по ссылкам. Вкладки видны ВСЕГДА, а не
             появляются при наличии ссылок: отсутствие вкладки читается как
             «такой возможности нет», и пользователь о ней не узнает. -->
        <div class="search-tabs" v-if="command === 'globalSearch'">
            <button type="button" :class="['search-tab', !refsMode ? 'search-tab--active' : '']"
                    @click="setRefsMode(false)" v-wjTooltip="t('Full-text search (F3)')">
                <i class="pi pi-search"></i> {{ t('Text') }}
            </button>
            <button type="button" :class="['search-tab', refsMode ? 'search-tab--active' : '']"
                    @click="setRefsMode(true)" v-wjTooltip="t('Reference search: who refers to this id (Shift+F3)')">
                <i class="pi pi-share-alt"></i> {{ t('References') }}
            </button>
        </div>

        <div class="search-input" v-if="command !== 'globalHistory'">
            <i :class="['pi', 'p-2', isLoading ? 'pi-spin pi-spinner' : pi]"></i>
            <div class="grid-chips">
                <span class="p-float-label">
                    <AttrChips ref="chips"
                        :widget_id="widget_id"
                        :initialAttr="chipsAttr"
                        v-model="CHIPS"
                        @update:modelValue="apply_globalSearch"
                        :mode="'Legacy'"
                    ></AttrChips>
                    <!-- <label for="chips">Search...</label> -->
                </span>
            </div>

            <div class="commandPanel" v-if="commandPanel.length">
                <component
                    v-for="attrM in commandPanel"
                    :key="attrM"
                    :widget_id="widget_id" 
                    :is="attrM.component"
                    :attr_id="attrM.id"
                    :initialAttr="attrM"
                />
            </div>
        </div>

        <!-- IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): фасеты стоят на месте и заливаются (toggle-chip, как ряд компаний в выборе баз); фильтр уходит в запрос
             (facet_requestChips), в ряд фильтра не переносится. Повторный клик снимает выбор -->
        <div class="search-collections search-facets" v-if="command !== 'globalHistory' && activeCommand !== 'globalRefs'">
            <template v-for="b in ['collection', 'segment', 'status', 'widget']" :key="b">
                <span v-for="(item, index) in facetRows(b)" :key="b + index"
                      :class="['toggle-chip', 'search-facet', 'search-facet--' + b, { active: facetActive(b, item[b]) }]"
                      @click="clickFacet(b, item[b], refsTitle(item, b))"
                      v-wjTooltip="t('Filter by this value — click again to clear')">● {{ refsTitle(item, b) }} {{ store.formatCount(item.count) }}</span><!-- IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): титул — из словаря на рисовании (refsTitle), не замороженный item[b + '.title'] -->
            </template>
        </div>

        <!-- ODOO-4334: ВЕРХНЯЯ ПАНЕЛЬ УТОЧНЕНИЯ по коллекциям — механика полнотекстового
             поиска, но своя разметка и свои ключи ответа: у вкладок общий шаблон, и
             чужие data_collection тут отрисовались бы поверх. Одна коллекция — выбора
             нет, чипсы не показываем. -->
        <!-- IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): тот же ряд-переключатель; выбранный держит ряд (снимок без своего фильтра), поэтому условие — не только длина -->
        <div class="search-collections search-facets" v-if="activeCommand === 'globalRefs' && (facetRows('collection').length > 1 || facetActiveAny('collection'))">
            <span v-for="(item, index) in facetRows('collection')" :key="index"
                  :class="['toggle-chip', 'search-facet', 'search-facet--collection', { active: facetActive('collection', item.collection) }]"
                  @click="clickFacet('collection', item.collection, refsTitle(item, 'collection'))"
                  v-wjTooltip="t('Refine the search by this collection')">● {{ refsTitle(item, 'collection') }} {{ item.count_title }}</span>
        </div>

        <!-- webscm 2026 10 25 / ODOO-4334 (шаг 1): ссылки ограничены МОДЕЛЬЮ цели — id «6» здесь товар #6, а не склад #6 и не
             пользователь #6. Клик снимает ограничение: для набранного числа панель снова спросит модель.
             .stop у кликов чипса и списка моделей обязателен: обработчик сразу убирает их из разметки, панель становится ниже, и
             «клик мимо панели» (handleClickOutside, по координатам мыши) на всплытии закрыл бы её — поймано headless-прогоном. -->
        <div class="search-collections refs-scope" v-if="refsScopeInfo">
            <div class="search-item" @click.stop="clearRefsScope" v-wjTooltip="t('References to this model only — click to choose another model')">
                <span class="meta-chip segment">● {{ refsScopeInfo.title }}</span>
                <span class="meta field" v-if="refsScopeInfo.model">{{ refsScopeInfo.model }}</span>
                <span class="meta collection" v-if="refsScopeInfo.connector_title">{{ refsScopeInfo.connector_title }}</span>
                <i class="pi pi-times refs-scope-clear"></i>
            </div>
        </div>

        <!-- webscm 2026 10 25 / ODOO-4334 (шаг 1): моделей с этим id столько, что бэкенд не успел их посчитать (globalRefsTargets →
             timed_out, targets пустой: частичного списка #466 не шлёт). Поиск по ВСЕМ моделям здесь — та смесь «товар #6 + склад #6»,
             которую владелец отверг, поэтому панель его не запускает, а просит модель: Shift+F3 по ячейке-ссылке (она несёт модель). -->
        <div class="search-empty search-empty--unsupported refs-timed-out" v-if="refsTimedOut">
            <i class="pi pi-exclamation-triangle"></i>
            {{ t('Too many references to count quickly — pick a model') }}
        </div>

        <!-- webscm 2026 10 25 / ODOO-4334 (шаг 1): «на какую модель?» — ссылки с этим числом есть у нескольких моделей. Число в строке —
             ссылки на объект ЭТОЙ модели; «все модели» — прежний поиск без ограничения. Условия !refsTimedOut ниже — защита: на timed_out
             #466 шлёт пустой targets, и список не рисуется вовсе; пришёл бы список — без заголовка и без «все модели» (это и есть смесь). -->
        <div class="search-results refs-targets" v-if="refsPicking">
            <div class="refs-targets-head" v-if="!refsTimedOut">{{ t('Id {id} belongs to several models — which object do you mean?', { id: refsTargets.id }) }}</div>
            <ul>
                <li v-for="(tg, ti) in refsTargets.targets" :key="ti" class="search-item" @click.stop="pickRefsTarget(tg)">
                    <span class="search-id refs-count">{{ store.formatCount(tg.count) }}</span>
                    <span class="meta-chip segment">● {{ tg.title }}</span>
                    <span class="meta field" v-if="tg.model">{{ tg.model }}</span>
                    <span class="meta collection" v-if="tg.connector_title">{{ tg.connector_title }}</span>
                </li>
                <li class="search-item refs-targets-all" v-if="!refsTimedOut" @click.stop="pickRefsTarget(null)">
                    <span class="search-id refs-count">{{ store.formatCount(refsTargets.count_total) }}</span>
                    <span>{{ t('All models (as before)') }}</span>
                </li>
            </ul>
        </div>

        <!-- ODOO-4334: ИЕРАРХИЯ «вид объекта → поле → примеры». Плоский список путей
             нечитаем ровно там, где панель нужнее всего: на самой ссылаемой сущности
             Биосферы 19 видов, 34 поля и 40 672 ссылки. Вид объекта скрываем, когда он
             один: выбирать не из чего. -->
        <div class="search-results refs-tree" v-if="activeCommand === 'globalRefs' && refsGroups.length">
            <!-- ODOO-4334: прерванный прогон сборки — не редкость (на Bio подряд
                 прервались work.records и datahub.inbound). Выдача при этом верна
                 по тому, что в графе есть, и неполна по тому, чего в нём нет.
                 Молчать нельзя: недосчёт, выданный за истину, — та же ложь. -->
            <div class="refs-incomplete" v-if="answer?.graph_complete === false"
                 v-wjTooltip="answer?.graph_build?.title || ''">
                <i class="pi pi-exclamation-triangle"></i>
                {{ t('Graph build is not complete — some references may be missing') }}
            </div>
            <!-- ОТСТАВАНИЕ. На базе с активным пересчётом граф вырождается за один
                 цикл: пересчёт снимает рёбра удалением строк, а обратная вставка
                 их не возвращает. Пользователь должен видеть, что смотрит на
                 снимок, а не на текущее состояние. -->
            <div class="refs-incomplete" v-if="refsLagText">
                <i class="pi pi-clock"></i> {{ refsLagText }}
            </div>
            <div class="refs-group" v-for="(group, gi) in refsGroups" :key="gi">
                <div class="refs-group-head" v-if="refsGroups.length > 1">
                    <span class="search-id refs-count">{{ group.count_title }}</span>
                    <span class="meta-chip segment refs-chip"
                          @click="addInSearch('segment', group.source_segment, refsTitle(group, 'source_segment'))"
                          v-wjTooltip="t('Refine by this object type')">
                        ● {{ refsTitle(group, 'source_segment') }}
                    </span>
                    <span class="meta-chip collection">● {{ refsTitle(group, 'source_collection') }}</span>
                </div>
                <div class="refs-fields">
                    <span class="meta-chip field refs-chip" v-for="(f, fi) in group.fields" :key="fi"
                          @click="addInSearch('path', f.path, f.binding)"
                          v-wjTooltip="t('Refine by this field')">
                        {{ f.binding }} <b>{{ f.count_title }}</b><i v-if="f.is_tabular"> · {{ t('tabular section') }}</i>
                    </span>
                </div>
                <ul class="refs-samples">
                    <li v-for="(s, si) in group.samples" :key="si" class="search-item" @click="openRefsSample(group, s)">
                        <span class="search-title">{{ s.title || s.id }}</span>
                        <span class="meta field">• {{ s.path }}</span>
                        <!-- тайтла может не быть, и это не сбой: у TXN и ALLOC он пуст
                             у всех записей. Показываем id и не выдумываем подпись. -->
                        <span class="meta" v-if="!s.title">• {{ t('no title, id shown') }}</span>
                    </li>
                </ul>
                <div class="refs-more" @click="openRefsRow({ source_collection: group.source_collection, source_segment: group.source_segment, path: '' })">
                    {{ t('Show all documents of this type') }} →
                </div>
            </div>
        </div>

        <div v-if="displayData.length && !refsGroups.length" class="search-results">
            <ul>
                <li v-for="(item, index) in displayData" :key="index" @click="selectItem('open', item)"
                    :class="['search-item', command === 'globalHistory' && !item._WIDGET?._softClosed && !item._WIDGET?.close ? 'search-item--open' : '']"
                >
                    <!-- ODOO-4334: строка графа ссылок — сегмент, поле, число вхождений.
                         Список самих рёбер не показываем: у горячей цели их сотни тысяч,
                         поэтому бэкенд и отдаёт агрегат с отсечением (count_title = «N+»). -->
                    <div class="search-content" v-if="activeCommand === 'globalRefs'">
                        <div class="order-number">
                            <span class="search-id refs-count">{{ item.count_title }}</span>
                            <span class="meta-chip segment">● {{ refsTitle(item, 'source_segment') }}</span>
                            <span class="meta-chip collection">● {{ refsTitle(item, 'source_collection') }}</span>
                            <span class="meta field" v-if="item.is_tabular">• {{ t('tabular section') }}</span>
                        </div>
                        <div class="search-title">{{ item.binding }}</div>
                    </div>

                    <div class="search-content" v-else-if="command === 'globalSearch'">
                        <div class="order-number">
                            <span class="search-id" v-html="item.highlightedID"></span>
                            <span class="meta link" @click.stop="selectItem('copyToClipboard', item)" v-wjTooltip="t('Copy to clipboard')"> <i class="pi pi-copy"></i> </span>
                            <span class="meta link" @click.stop="selectItem('openInNewTab', item)" v-wjTooltip="t('Open record in new tab')"> <i class="pi pi-external-link"></i> </span>
                            <span class="meta-chip collection" @click.stop="addInSearch('collection', item._meta.collection, refsTitle(item, '_meta.collection'))" v-wjTooltip="t('Add collection in search')">● {{ refsTitle(item, '_meta.collection') }}</span><!-- IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): титул из словаря на рисовании -->
                            <span class="meta-chip segment" @click.stop="addInSearch('segment', item.segment, refsTitle(item, 'segment'))" v-wjTooltip="t('Add segment in search')">● {{ refsTitle(item, 'segment') }}</span><!-- IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): титул из словаря на рисовании -->
                        </div>
                        <div class="search-title" v-html="item.highlightedTitle"></div>
                        <div class="search-info-0">
                            <span class="meta field">• {{ t('Field') }}: {{ item._meta.binding }}</span>
                            <span class="meta date">• {{ t('Updated at') }}: {{ (item.updated_at||'').slice(0, 19) }}</span>
                        </div>
                        <div class="search-info-0">
                            <span class="meta value">• {{ t('Value') }}: <span v-html="(item._meta.highlightedValue || '').slice(0, 100)"></span></span>
                        </div>
                    </div>

                    <div class="search-content search-content--row" v-else-if="command === 'globalHistory'">
                        <input type="checkbox" class="history-checker"
                            :checked="!item._WIDGET?._softClosed && !item._WIDGET?.close"
                            :disabled="!!item._WIDGET?.close"
                            @click.stop="toggleWidgetSoftClosed(item)"
                            v-wjTooltip="item._WIDGET?._softClosed ? t('Restore widget') : t('Close widget')"
                        />
                        <span class="segment-title pi-header pi-1 widget-mini-badge" v-if="item._WIDGET">
                            <i :class="[item._WIDGET.pi, 'pi-header-pi']" v-if="item._WIDGET.pi"></i>
                            {{ item._WIDGET.shortTitle }}
                        </span>
                        <div class="search-title" v-html="item.highlightedTitle"></div>
                        <div class="order-number">
                            <span class="search-id" v-html="item.record_id"></span>
                        </div>
                        <div class="widget-mini-btns">
                            <span class="meta link" @click.stop="store?.externalLink({method:'copyToClipboard', action_id:item._WIDGET?.record?._meta?.action_id})" v-wjTooltip="t('Copy to clipboard')"><i class="pi pi-copy"></i></span>
                            <span class="meta link" @click.stop="store?.externalLink({method:'openInNewTab', action_id:item._WIDGET?.record?._meta?.action_id})" v-wjTooltip="t('Open record in new tab')"><i class="pi pi-external-link"></i></span>
                        </div>
                    </div>

                    <div class="search-content" v-else-if="command === 'globalJob'">
                        <div class="order-number">
                            <span class="search-id" v-html="item.record_id"></span>
                            <span class="meta link" @click.stop="store?.externalLink({method:'copyToClipboard', action_id:item.id})" v-wjTooltip="t('Copy to clipboard')"> <i class="pi pi-copy"></i> </span>
                            <span class="meta link" @click.stop="store?.externalLink({method:'openInNewTab', action_id:item.id})" v-wjTooltip="t('Open record in new tab')"> <i class="pi pi-external-link"></i> </span>
                            <span class="meta-chip segment" @click.stop="addInSearch('segment', item.segment, refsTitle(item, 'segment'))" v-wjTooltip="t('Add segment in search')">● {{ refsTitle(item, 'segment') }}</span><!-- IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): титул из словаря на рисовании -->
                            <span class="meta-chip widget" @click.stop="addInSearch('widget', item.widget, refsTitle(item, 'widget'))" v-wjTooltip="t('Add widget in search')">● {{ refsTitle(item, 'widget') }}</span><!-- IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): титул из словаря на рисовании -->
                        </div>
                        <div class="search-title" v-html="item.highlightedTitle"></div>
                        <div class="search-info-0">
                            <span class="meta date">• {{ t('Updated at') }}: {{ (item.created_at||'').slice(0, 19) }}</span>
                        </div>
                    </div>
                    <div class="search-content" v-else-if="command === 'globalLog'">
                        <div class="order-number">
                            <span class="search-id" v-html="item.highlightedID"></span>
                            <span class="meta link" @click.stop="selectItem('copyToClipboard', item)" v-wjTooltip="t('Copy to clipboard')"> <i class="pi pi-copy"></i> </span>
                            <span class="meta link" @click.stop="selectItem('openInNewTab', item)" v-wjTooltip="t('Open record in new tab')"> <i class="pi pi-external-link"></i> </span>
                            <!-- <span class="meta-chip collection" @click.stop="addInSearch('collection', item._meta.collection, item['_meta.collection.title'])" v-wjTooltip="'Add in search'">● {{ item['_meta.collection.title'] }}</span> -->
                            <span class="meta-chip segment" @click.stop="addInSearch('segment', item.segment, refsTitle(item, 'segment'))" v-wjTooltip="t('Add segment in search')">● {{ refsTitle(item, 'segment') }}</span><!-- IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): титул из словаря на рисовании -->
                            <span class="meta-chip widget" @click.stop="addInSearch('widget', item.widget, refsTitle(item, 'widget'))" v-wjTooltip="t('Add widget in search')">● {{ refsTitle(item, 'widget') }}</span><!-- IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): титул из словаря на рисовании -->
                            <span class="meta-chip status" @click.stop="addInSearch('status', item.status, refsTitle(item, 'status'))" v-wjTooltip="t('Add status in search')">● {{ refsTitle(item, 'status') }}</span><!-- IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): титул из словаря на рисовании -->
                        </div>
                        <div class="search-title" v-html="item.highlightedTitle"></div>
                        <div class="search-info-0">
                            <span class="meta duration">• {{ t('Duration') }}: {{ store.formatTimeHTML(item.duration) }}</span><!-- IE 2026 09 24 / ODOO-341407: при показе — единицы под текущий язык (живое переключение) -->
                            <span class="meta date">• {{ t('Updated at') }}: {{ (item.created_at||'').slice(0, 19) }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <!-- ODOO-4334: вкладка ссылок видна всегда, значит пустой ответ обязан
             объяснять себя сам — иначе пустота читается как поломка. И случаи
             пустоты РАЗНЫЕ: нечего искать, искать нечем, ничего не нашлось;
             причину подбирает refsUnavailableReason. -->
        <div :class="['search-empty', refsUnsupported ? 'search-empty--unsupported' : '']"
             v-if="activeCommand === 'globalRefs' && !displayData.length && !refsGroups.length && !isLoading && !refsPicking && !refsTimedOut">
            <template v-if="refsUnsupported">
                <i class="pi pi-exclamation-triangle"></i>
                {{ refsUnavailableText }}
            </template>
            <template v-else>
                {{ CHIPS.length ? t('Nothing refers to this id') : t('Enter an object id to see who refers to it') }}
            </template>
        </div>

        <!-- ODOO-4334: чего эта база НЕ УМЕЕТ. Деградация полнотекстового поиска
             молчалива: без trgm-индексов кусок id не находится в принципе, и
             пользователь читает пустой ответ как «поиск не работает» (жалоба с
             Биосферы, где нет ни индексов, ни колонки title). Пишем об этом только
             когда не нашлось: при удачном поиске это был бы шум. -->
        <div class="search-empty search-empty--unsupported"
             v-if="searchCapsText && !displayData.length && !isLoading">
            <i class="pi pi-exclamation-triangle"></i> {{ searchCapsText }}
        </div>

        <div class="external-search external-search--action" @click="store.restoreLastClosedWidget(); hide()" v-if="command === 'globalHistory'">
            <i class="pi pi-undo"></i>
            <span>{{ t('Restore last closed widget') }}</span>
            <kbd class="hotkey-badge">Alt Esc</kbd>
        </div>
        <!-- ODOO-4334: у вкладки ссылок «показать ещё» нет — агрегат и так полный,
             поэтому подвал не должен выглядеть кликабельным и пустым. -->
        <div :class="['external-search', activeCommand === 'globalRefs' ? 'external-search--static' : '']"
             @click="searchMore" v-if="formattedText">
            <div>{{ formattedText }}</div>
        </div>
    </div>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import Widget from './Widget.vue'
import { refs_isGuid, refs_searchValue, refs_targetsDecision, refs_requestParams } from '@/utils/refsTarget'   // webscm 2026 10 25 / ODOO-4334 (шаг 1)
import { facet_listKeys, facet_isBinding, facet_isActive, facet_click, facet_requestChips, facet_rows, facet_staleBases, facet_title, FACET_RELATION } from '@/utils/searchFacets' // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз)
import { refs_openList } from '@/utils/refsOpenList'   // webscm 2026 10 31 / Odoo 350449: переход «группа → документы» — общий с вкладкой References формы записи

export default {
    props: {
        command: { // globalSearch / globalHistory / globalLog / globalJob
            type: String,
            required: true,
        }
    },
    data() {
        return {
            // widget_id:'globalSearch',
            visible: false,
            isLoading: false,
            position: { top: 5, left: 250, width: 700 },
            answer: {},
            CHIPS: [],
            searchQuery: '...',
            chipsAttr: {
                'showCHIP-Limit': true,
                'CHIP-Limit_defaults': { limit: 5, offset: 0 },
            },
            commandPanel: [
                // { name: 'command-search', title: 'Search', cssClass: 'pi p-button-white p-2 pi-clone', command:'widget_open', widget:'widget-search'},
            ],
            pi: 'pi-search',
            comment: '',
            refsMode: false, // ODOO-4334: вкладка «Ссылки» вместо полнотекстового поиска
            answerCommand: '', // какой командой получен текущий answer (см. displayData)
            refsUnsupported: false, // ссылкам верить нельзя (см. refsUnavailableReason)
            refsUnavailableText: '', // почему именно нельзя — текст для пользователя
            // webscm 2026 10 25 / ODOO-4334 (шаг 1): модель цели. Принадлежит тому id, для которого выбрана (refs_requestParams)
            refsScope: null,              // { id, segment } — Shift+F3 по ссылке / своей записи или выбор из списка
            refsTargets: null,            // ответ globalRefsTargets для refsTargets.id — список «на какую модель?»
            refsAllModelsId: '',          // id, для которого выбрано «все модели» (поиск как раньше)
            refsTargetsUnsupported: false, // бэкенд без globalRefsTargets — набранный id ищется как раньше
            facetState: {}, // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): по вкладке (activeCommand) — { sel: {binding: {value, title}}, base: {binding: rows} }
        }
    },
    setup() {
        const store = useMainStore()
        
        return { store }
    },
    created() {
        this.widget_id = this.store.nextWidget_id++
        this.store.WIDGETS[this.widget_id] = {
            id: this.widget_id,
            workspace: 'workspace-store',
            page: 'page-store',
            widget: 'widget_GLOBAL_SEARCH',
            vueObj: this,
            record: {
                doc: { limit: 5, offset: 0, _limit_total_count: 0 },
            },
            attrs_vueObj: {
                WIDGET: this,
            },
        }
        this.WIDGET = this.store.WIDGETS[this.widget_id] // реактивный proxy: doc.limit/offset читает AttrChips (CHIP-Limit)
        this.store.prepare_attrs(this.commandPanel, 'globalSearch')
        if (this.command === 'globalHistory') {
            this.pi = 'pi-hourglass'
        } else if (this.command === 'globalJob') {
            this.pi = 'pi-comment'
        } else if (this.command === 'globalLog') {
            this.pi = 'pi-history'
        }
    },
    mounted() {
    },
    methods: {
        show(search_value, activeElement, opts) {
            // ODOO-4334: Shift+F3 и иконка ссылки открывают форму сразу на вкладке
            // ссылок; обычный F3 возвращает её к тексту, а не оставляет как было —
            // иначе привычный хоткей однажды молча ищет не то.
            if (this.command === 'globalSearch') this.refsMode = !!opts?.refs
            // webscm 2026 10 25 / ODOO-4334 (шаг 1): Shift+F3 по ссылке / своей записи приносит модель цели — спрашивать её не нужно
            if (this.command === 'globalSearch') {
                this.refsTargets = null
                this.refsAllModelsId = ''
                this.refsScope = (opts?.refs && opts?.target_segment && search_value) ? { id: String(search_value).trim(), segment: opts.target_segment } : null
            }
            if (search_value) {
                this.facetState = {} // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): новый поиск — без прежнего выбора (раньше его CHIP-Where уходил вместе с CHIPS)
                this.CHIPS.splice(0, this.CHIPS.length, {
                    segment: 'CHIP-Search', 
                    title: search_value,
                    meta: {
                        use: true,
                        pi: 'pi-search',
                    },
                });
            }
            this.activeElement = activeElement
            this.visible = true
            if (this.command === 'globalHistory') {
                this.store._seedFrontHistory()
            }
            this.apply_globalSearch()

            this.store.dropdown?.hide()

            this.handleClickOutside = (event) => {
                if (this.$refs.searchBox && !this.store.mouse_isInside(this.$refs.searchBox)) { // !this.$refs.searchBox.contains(event.target)
                    this.hide()
                }
            }

            this.handleKeydown = (event) => {
                if (event.key === "Escape") {
                    this.hide()
                    if (this.command === 'globalJob') {
                        this.$refs.comment?.focus()
                    } else if (this.activeElement) {
                        this.activeElement.focus()
                    }
                }
            }

            this._showTimerId = window.$cg.setTimeout(this, "Search.show", () => {
                document.addEventListener("click", this.handleClickOutside)
                document.addEventListener("keydown", this.handleKeydown)

                if (this.command === 'globalJob') {
                    this.$refs.comment?.focus()
                } else {
                    this.$refs.chips?.focus()
                }
            }, 100)
        },
        hide() {
            this.visible = false
            window.clearTimeout(this._showTimerId)
            document.removeEventListener("click", this.handleClickOutside)
            document.removeEventListener("keydown", this.handleKeydown)
        },
        apply_globalSearch(value, opts) {
            if (this.command === 'globalHistory') return
            const doc = this.WIDGET.record.doc
            if (!opts?.keepOffset) doc.offset = 0 // изменение чипсов возвращает на первую страницу; keepOffset — пейджинг CHIP-Limit
            if (this.CHIPS.length || this.command !== 'globalSearch') {
                const seq = this._searchSeq = (this._searchSeq || 0) + 1
                this.isLoading = true
                // страховка: executeBackendMethod не вызывает callback при ошибке
                this._loadingTimerId = window.$cg.setTimeout(this, "Search.apply_globalSearch", () => {
                    if (seq === this._searchSeq) this.isLoading = false
                }, 30000)
                // ODOO-4334: команду запоминаем НА МОМЕНТ ЗАПРОСА. Ответы двух вкладок
                // несовместимы по форме (у ребра нет _meta), и запоздавший ответ,
                // разобранный веткой другой вкладки, роняет разбор целиком.
                const cmd = this.activeCommand
                // webscm 2026 10 25 / ODOO-4334 (шаг 1): набранное число — сначала «на какую модель?», поиск — после выбора
                if (cmd === 'globalRefs' && this.refsAskTargets(seq)) return
                this.store.executeBackendMethod(this, {
                    method: cmd,
                    params: {
                        CHIPS: facet_requestChips(this.CHIPS, this.facetState[cmd]?.sel), // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз)
                        limit: doc.limit ?? 5,
                        offset: doc.offset || 0,
                        // webscm 2026 10 25 / ODOO-4334 (шаг 1): счёт без задвоения слоёв и модель цели (старый бэкенд их не читает)
                        ...(cmd === 'globalRefs' ? refs_requestParams(this.refsScope, refs_searchValue(this.CHIPS)) : {}),
                    }
                }, (answer) => {
                    if (seq !== this._searchSeq) return // устаревший ответ — выбрасываем
                    this.isLoading = false
                    window.clearTimeout(this._loadingTimerId)
                    this.load_globalSearch(answer, cmd)
                })
                if (!opts?.keepOffset) this.refreshFacetBases(cmd, seq, opts?.facet) // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): пейджинг счётчиков не меняет
            } else {
                this.data = []
                this.answer = {}
                doc._limit_total_count = 0
                this.isLoading = false
            }
        },
        load_globalSearch(answer, cmd = this.activeCommand) {
            this.answer = answer
            this.answerCommand = cmd

            // ODOO-4334: рёбра — не записи. У строки globalRefs нет ни _meta, ни
            // подсветки, и общий разбор ниже на ней падает (item._meta.value).
            // Пагинации у агрегата тоже нет: групп единицы, бэкенд отдаёт их все,
            // поэтому _limit_total_count оставляем нулём — иначе CHIP-Limit
            // предложит вторую страницу, которой не существует.
            if (cmd === 'globalRefs') {
                this.WIDGET.record.doc._limit_total_count = 0
                this.refsUnavailableText = this.refsUnavailableReason(answer, 'data')
                this.refsUnsupported = !!this.refsUnavailableText
                if (this.refsUnsupported) return
                // подписи рисует refsTitle (словарь в момент рисования); эти вызовы ещё и ЗАПРАШИВАЮТ словарь SEGMENTS-UNION целиком
                this.store.get_itemsSource(this, answer.data, {binding:'source_segment', attr_type:'AttrLink', relation_segment:'SEGMENTS-UNION'}, {fill:'fill.title', fetchMode: 'all'})
                this.store.get_itemsSource(this, answer.data, {binding:'source_collection', attr_type:'AttrLink', relation_segment:'SEGMENTS-UNION'}, {fill:'fill.title', fetchMode: 'all'})
                // те же титулы для иерархии и чипсов коллекций — это отдельные наборы
                // строк, титул из answer.data на них не переносится
                this.store.get_itemsSource(this, answer.data_groups, {binding:'source_segment', attr_type:'AttrLink', relation_segment:'SEGMENTS-UNION'}, {fill:'fill.title', fetchMode: 'all'})
                this.store.get_itemsSource(this, answer.data_groups, {binding:'source_collection', attr_type:'AttrLink', relation_segment:'SEGMENTS-UNION'}, {fill:'fill.title', fetchMode: 'all'})
                this.store.get_itemsSource(this, answer.refs_collections, {binding:'collection', attr_type:'AttrLink', relation_segment:'SEGMENTS-UNION'}, {fill:'fill.title', fetchMode: 'all'})
                return
            }

            this.WIDGET.record.doc._limit_total_count = answer.data_count ?? 0
            this.store.get_itemsSource(this, answer.data, {binding:'segment', attr_type:'AttrLink', relation_segment:'SEGMENTS-UNION'}, {fill:'fill.title', fetchMode: 'all'})
            this.store.get_itemsSource(this, answer.data, {binding:'_meta.collection', attr_type:'AttrLink', relation_segment:'SEGMENTS-UNION'}, {fill:'fill.title', fetchMode: 'all'})

            this.store.get_itemsSource(this, answer.data_collection, {binding:'collection', attr_type:'AttrLink', relation_segment:'SEGMENTS-UNION'}, {fill:'fill.title', fetchMode: 'all'})
            this.store.get_itemsSource(this, answer.data_segments, {binding:'segment', attr_type:'AttrLink', relation_segment:'SEGMENTS-UNION'}, {fill:'fill.title', fetchMode: 'all'})
            
            // log
            this.store.get_itemsSource(this, answer.data, {binding:'widget', attr_type:'AttrLink', relation_segment:'WIDGETS-TASKS'}, {fill:'fill.title', fetchMode: 'all'})
            this.store.get_itemsSource(this, answer.data, {binding:'status', attr_type:'AttrLink', relation_segment:'STATUS'}, {fill:'fill.title', fetchMode: 'all'})
            
            this.store.get_itemsSource(this, answer.data_widgets, {binding:'widget', attr_type:'AttrLink', relation_segment:'WIDGETS-TASKS'}, {fill:'fill.title', fetchMode: 'all'})
            this.store.get_itemsSource(this, answer.data_statuses, {binding:'status', attr_type:'AttrLink', relation_segment:'STATUS'}, {fill:'fill.title', fetchMode: 'all'})

            for (const item of answer.data || []) {
                item['duration.title'] = this.store.formatTimeHTML(item.duration)
            }

            for (const item of answer.data || []) {
                if (item._frontendEntry) continue
                item.highlightedID = this.store.check_CHIPS_highlighted(this.WIDGET, item.id, this.CHIPS)
                item.highlightedTitle = this.store.check_CHIPS_highlighted(this.WIDGET, item.title, this.CHIPS)
                item._meta.highlightedValue = this.store.check_CHIPS_highlighted(this.WIDGET, item._meta.value, this.CHIPS)
            }
        },
        // webscm 2026 10 26 / ODOO-4334: подпись вида объекта / коллекции в панели ссылок. Ответ globalRefs несёт только id (segment-1949),
        // титул — из словаря SEGMENTS-UNION, и берём его ПРИ РИСОВАНИИ, а не из строки ответа: к первому открытию словарь обычно частичный
        // (by_ids других виджетов: Bio 15 строк, Demo7 11), fill.title пишет в строку сырой id, а полный словарь, приехавший через ~0.7 с,
        // строку уже не правит — заголовки групп оставались «segment-1949» до повторного открытия. Приход словаря бампает
        // itemsSource_change_index — перерисовка
        refsTitle(row, key) {
            // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): тот же разбор для фасетов и чипсов строк выдачи (segment / status / widget / _meta.collection) — utils/searchFacets.facet_title,
            // словарь по binding (FACET_RELATION), не только SEGMENTS-UNION
            void this.store.itemsSource_change_index
            return facet_title(this.store.itemsSource, row, key)
        },
        // webscm 2026 10 25 / ODOO-4334 (шаг 1): числовой id объект не называет (на Demo7 «6» — у 138 моделей), поэтому до поиска панель
        // спрашивает модель (globalRefsTargets). true — запрос ушёл или список уже на экране (поиск — после выбора); false — искать сразу:
        // модель известна (Shift+F3, выбор из списка), GUID, выбрано «все модели», бэкенд без метода (старый стенд) или роль «только
        // чтение» на таком бэкенде (метод не в её белом списке — отказ молча оставил бы панель без ответа)
        refsAskTargets(seq) {
            const id = refs_searchValue(this.CHIPS)
            if (this.refsScope && this.refsScope.id !== id) this.refsScope = null
            if (this.refsTargets && this.refsTargets.id !== id) this.refsTargets = null
            if (!id || this.refsScope || refs_isGuid(id) || this.refsAllModelsId === id || this.refsTargetsUnsupported) return false
            if (!this.refsTargets && !this.store.readonly_allows('executeBackendMethod', 'globalRefsTargets')) return false
            const showList = (targets) => {
                this.isLoading = false
                window.clearTimeout(this._loadingTimerId)
                this.answer = {}
                this.answerCommand = 'globalRefs'
                this.refsUnsupported = false
                this.refsUnavailableText = ''
                this.refsTargets = targets
            }
            if (this.refsTargets) { showList(this.refsTargets); return true }
            this.store.executeBackendMethod(this, { method: 'globalRefsTargets', params: { id } }, (answer) => {
                if (seq !== this._searchSeq) return // устаревший ответ — выбрасываем
                const next = refs_targetsDecision(answer)
                // timed_out — сообщение «выберите модель» (targets пуст: частичного списка #466 не шлёт; показать его, если придёт, — защита):
                // по всем моделям не ищем, повторно не спрашиваем
                if (next.action === 'pick' || next.action === 'timed_out') { showList({ ...answer, id }); return }
                if (next.action === 'fallback') this.refsTargetsUnsupported = true
                else if (next.action === 'scope') this.refsScope = { id, segment: next.target.target_segment }
                else this.refsAllModelsId = id
                this.apply_globalSearch()
            })
            return true
        },
        pickRefsTarget(target) {
            const id = this.refsTargets?.id
            if (!id) return
            if (target) this.refsScope = { id, segment: target.target_segment }
            else this.refsAllModelsId = id
            this.refsTargets = null
            this.apply_globalSearch()
        },
        clearRefsScope() {
            this.refsScope = null
            this.refsAllModelsId = ''
            this.answer = {}
            this.apply_globalSearch()
        },
        setRefsMode(on) {
            if (this.refsMode === !!on) return
            this.refsMode = !!on
            this.answer = {}
            this.refsUnsupported = false // пересчитается по ответу
            this.refsUnavailableText = ''
            this.apply_globalSearch()
        },
        // ЧЕСТНАЯ ДЕГРАДАЦИЯ: почему ответу про ссылки нельзя верить, '' если можно.
        // Пустой ответ бывает ЧЕТЫРЁХ происхождений, и только одно из них значит
        // «ничего не ссылается» — остальные три обязаны сказать о себе вслух,
        // иначе панель отвечает уверенной ложью:
        //   1. метода нет вовсе. Диспетчер бэкенда на неизвестный метод не
        //      ругается — ветка просто не выбирается, и приходит HTTP 200 с
        //      пустым ответом (ODOO-4690). Видно по отсутствию самого ключа.
        //   2. метод есть, но граф на базе не построен. Бэкенд с проверкой
        //      готовности говорит это прямым признаком graph_ready.
        //   3. то же самое, но бэкенд ещё БЕЗ проверки: запрос падает на
        //      несуществующей search.refs, а select_query исключения не бросает —
        //      возвращает пустой data, ошибку кладёт в TERMINAL. Форма ответа
        //      правильная, смысл ложный (поймано на Bio, ODOO-4334). Признак
        //      недоступности — ошибка в TERMINAL при пустом наборе; сами строки
        //      пришли — значит запрос отработал, и чужая ошибка не в счёт.
        //   4. строки есть, но без binding — бэкенд старее контракта панели.
        refsUnavailableReason(answer, key) {
            // IE 2026 09 23 / ODOO-341407: i18n
            const rows = answer?.[key]
            if (!Array.isArray(rows)) {
                return this.t('Reference search is not available on this database — its backend does not support the reference graph')
            }
            if (answer.graph_ready === false) {
                return this.t('The reference graph is not built on this database yet — nothing to search in')
            }
            if (!rows.length && `${answer.TERMINAL || ''}`.includes('!!ERROR')) {
                return this.t('Failed to get references — the backend returned an error')
            }
            if (key === 'data' && rows.length && rows[0].binding === undefined) {
                return this.t('Reference search is not available on this database — its backend is older than the panel contract')
            }
            return ''
        },
        // Клик по ПРИМЕРУ открывает сам документ. Идём тем же путём, что и переход
        // по группе (сегмент + отбор по id), а не «открыть запись по id»: у примера
        // известен сегмент, и список открывается уже отфильтрованным.
        openRefsSample(group, sample) {
            this.store.widget_open({
                widget: 'widget-list',
                parentAction: { action_name:'action-front-2026-08-12-refs-sample', method:'Search.openRefsSample' },
                fieldsMapping: [
                    { leftValue:'doc.params.segment', rightValue: group.source_segment },
                    { leftValue:'doc.params.WHERE', rightValue:{ value:[
                        { use:true, leftValue:'id', condition:'in', rightValue:[sample.id] },
                    ], valueAsIs:true } },
                ],
            }, this)
            this.hide()
        },
        openRefsRow(item) {
            // IE 2026 09 23 / ODOO-341407: i18n (notification texts)
            // Переход «группа → документы» идёт по СПИСКУ ID из графа, а не условием
            // по полю: условие по табличной части штатным WHERE даёт пустой список
            // без ошибки (ODOO-4114), а по графу оба случая работают одинаково.
            // id берём ИЗ ОТВЕТА, а не из чипсов: бэкенд склеивает все чипсы поиска
            // в одну строку, и по двум чипсам агрегат и список id посчитались бы
            // для разных целей.
            // webscm 2026 10 31 / Odoo 350449: шаги вынесены в utils/refsOpenList.refs_openList (общие с вкладкой References формы записи);
            // панель — прежним путём: фиксированный doc.params.WHERE (route 'where'), своя проверка ответа, после открытия панель прячется
            const target_id = (this.answer?.id || '').trim()
            if (!target_id) return
            refs_openList(this.store, this, {
                id: target_id,
                source_collection: item.source_collection,
                source_segment: item.source_segment,
                path: item.path,
                // webscm 2026 10 25 / ODOO-4334 (шаг 1): та же модель цели и тот же счёт, что у агрегата на экране
                target_segment: (this.answer?.target_segments || []).map(row => row?.target_segment).filter(Boolean),
                dedup: true,
            }, {
                route: 'where',
                parentAction: { action_name:'action-front-2026-08-09-refs', method:'Search.openRefsRow' },
                t: this.t,
                // «Документы не найдены» здесь было бы такой же ЛОЖЬЮ, как пустая
                // панель: документы есть, спросить не у кого. Причины те же, что и
                // у агрегата, поэтому проверка одна на двоих.
                unavailable: (answer) => this.refsUnavailableReason(answer, 'ids'),
                onUnavailable: (reason) => {
                    this.refsUnsupported = true
                    this.refsUnavailableText = reason
                },
                onOpened: () => this.hide(),
            })
        },
        selectItem(method, item) {
            if (this.activeCommand === 'globalRefs') {
                if (method === 'open') this.openRefsRow(item)
                return
            }
            if (method === 'open') {
                if (item._frontendEntry) {
                    if (item._WIDGET?._softClosed) {
                        this.store._widget_restoreSoftClosed(item._WIDGET)
                        this.store.widget_activate(item._WIDGET, 'history::restore_softClosed', true, true)
                    } else if (!item._WIDGET?.close) {
                        this.store.widget_activate(item._WIDGET, 'history::activate', true, true)
                    } else {
                        this.store.show_notification({ text: this.t('Widget was already purged'), status: 'warning' })   // IE 2026 09 23 / ODOO-341407: i18n
                    }
                } else {
                    this.store.executeStoreMethod(this, { action_name:'action-front-2025-01-29-1', command:'widget_open', widget:'widget-record', item })
                }
                this.hide()
            } else if (method === 'copyToClipboard') {
                this.store.executeStoreMethod(this, { action_name:'action-front-2025-01-29-2', command:'widget_open', widget:'widget-record', item, externalLink_method:method })
            } else if (method === 'openInNewTab') {
                this.store.executeStoreMethod(this, { action_name:'action-front-2025-01-29-3', command:'widget_open', widget:'widget-record', item, externalLink_method:method })
                this.hide()
            }
        },
        toggleWidgetSoftClosed(item) {
            if (!item._WIDGET || item._WIDGET.close) return
            const WIDGET = item._WIDGET
            const origIdx = this.store.frontHistory.indexOf(item)
            const origViewedAt = item.viewed_at
            if (WIDGET._softClosed) {
                this.store._widget_restoreSoftClosed(WIDGET)
                this.store.widget_activate(WIDGET, 'history::restore_softClosed', true, true)
            } else {
                this.store.widget_close(WIDGET.id)
            }
            if (origIdx >= 0) {
                const newIdx = this.store.frontHistory.findIndex(e => e._WIDGET === WIDGET)
                if (newIdx !== -1) {
                    this.store.frontHistory[newIdx].viewed_at = origViewedAt
                    if (newIdx !== origIdx) {
                        const [entry] = this.store.frontHistory.splice(newIdx, 1)
                        this.store.frontHistory.splice(origIdx, 0, entry)
                    }
                }
            }
        },
        newJob() {
            const el = this.$refs.comment
            const comment = el.innerText.trim()

            if (!comment) return

            el.innerText = ""
            
            this.store.executeBackendMethod(this, {
                method: 'globalJob_new',
                params: {
                    CHIPS: facet_requestChips(this.CHIPS, this.facetState[this.activeCommand]?.sel), // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз)
                    comment: comment,
                }
            }, this.load_globalSearch)
        },
        addInSearch(binding, value, title) {
            // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): binding с рядом фасетов (чипс строки выдачи «добавить в поиск») — тот же выбор в ряду, без второго фильтра в ряду чипсов
            if (facet_isBinding(this.activeCommand, binding)) return this.clickFacet(binding, value, title, false)
            this.$refs.chips?.setChipWhere(title, binding, '=', value)
            this.apply_globalSearch()
        },
        // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): ряд фасетов — живой ответ, а при выборе снимок без своего фильтра (ряд не сжимается до выбранного)
        facetRows(binding) {
            const cmd = this.activeCommand
            const key = facet_listKeys(cmd)[binding]
            if (!key) return []
            const live = cmd === 'globalRefs' ? this.refsCollections : (this.answer?.[key] || [])
            const st = this.facetState[cmd]
            return facet_rows(binding, live, st?.base?.[binding], st?.sel)
        },
        facetActive(binding, value) {
            return facet_isActive(this.facetState[this.activeCommand]?.sel, binding, value)
        },
        facetActiveAny(binding) {
            return !!this.facetState[this.activeCommand]?.sel?.[binding]
        },
        clickFacet(binding, value, title, toggle = true) {
            const cmd = this.activeCommand
            const next = facet_click(this.facetState[cmd], binding, value, title, this.facetRows(binding), toggle)
            if (!next) return
            this.facetState = { ...this.facetState, [cmd]: next }
            this.apply_globalSearch(null, { facet: binding })
        },
        // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): снимок ряда выбранного фасета — тем же запросом без СВОЕГО фильтра (limit 1: нужны счётчики, не строки). Нужен, когда
        // поменялось остальное (текст, другой фасет): иначе в ряду стояли бы счётчики прежнего запроса
        refreshFacetBases(cmd, seq, changed) {
            const sel = this.facetState[cmd]?.sel
            const key = facet_listKeys(cmd)
            for (const b of facet_staleBases(sel, changed)) {
                this.store.executeBackendMethod(this, {
                    method: cmd,
                    params: {
                        CHIPS: facet_requestChips(this.CHIPS, sel, b),
                        limit: 1,
                        offset: 0,
                        ...(cmd === 'globalRefs' ? refs_requestParams(this.refsScope, refs_searchValue(this.CHIPS)) : {}),
                    }
                }, (answer) => {
                    if (seq !== this._searchSeq) return // устаревший ответ
                    const st = this.facetState[cmd]
                    if (!st?.sel?.[b]) return // выбор уже снят
                    const rows = answer?.[key[b]] || []
                    if (cmd !== 'globalRefs') this.store.get_itemsSource(this, rows, {binding: b, attr_type:'AttrLink', relation_segment: FACET_RELATION[b]}, {fill:'fill.title', fetchMode: 'all'})
                    this.facetState = { ...this.facetState, [cmd]: { ...st, base: { ...st.base, [b]: rows } } }
                })
            }
        },
        searchMore() {
            // IE 2026 09 23 / ODOO-341407: i18n (widget titles)
            // у графа ссылок отдельного «списка всего» нет: агрегат и так полный
            if (this.activeCommand === 'globalRefs') return
            const moreChips = facet_requestChips(this.CHIPS, this.facetState[this.activeCommand]?.sel) // IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): тот же фильтр, что у выдачи
            if (this.command === 'globalSearch') {
                this.store.executeStoreMethod(this, { title: this.t('Search more...'), command:'widget_open', widget:'widget-search', params: {
                    CHIPS: moreChips,
                } })
            } else if (this.command === 'globalHistory') {
                this.store.executeStoreMethod(this, { title: this.t('View more activities...'), command:'widget_open', widget:'widget-historys', params: {
                    CHIPS: moreChips,
                } })
            } else if (this.command === 'globalJob') {
                this.store.executeStoreMethod(this, { title: this.t('Ask job...'), command:'widget_open', widget:'widget-jobs', params: {
                    CHIPS: moreChips,
                } })
            } else if (this.command === 'globalLog') {
                this.store.executeStoreMethod(this, { title: this.t('Log more...'), command:'widget_open', widget:'widget-logs', params: {
                    CHIPS: moreChips,
                } })
            }

            this.hide()
        },
    },
    computed: {
        // ODOO-4334: метод бэкенда определяется положением переключателя, а не
        // props: вкладка живёт только внутри globalSearch, остальные четыре
        // команды её не знают и работают как работали.
        activeCommand() {
            return this.refsMode && this.command === 'globalSearch' ? 'globalRefs' : this.command
        },
        // ODOO-4334: иерархия приезжает ОТДЕЛЬНЫМ ключом, а data остаётся плоским
        // списком полей. Поэтому этот же фронт работает и со старым бэкендом: там
        // data_groups нет, и панель рисует прежний плоский список.
        refsGroups() {
            if (this.activeCommand !== 'globalRefs' || this.refsUnsupported) return []
            if (this.answerCommand && this.answerCommand !== this.activeCommand) return []
            return this.answer?.data_groups || []
        },
        // webscm 2026 10 25 / ODOO-4334 (шаг 1): открыт список «на какую модель?»
        refsPicking() {
            return this.activeCommand === 'globalRefs' && !this.refsUnsupported && !!this.refsTargets?.targets?.length
        },
        // бэкенд не успел посчитать модели этого id (globalRefsTargets → timed_out): панель просит модель, по всем моделям не ищет
        refsTimedOut() {
            return this.activeCommand === 'globalRefs' && !this.refsUnsupported && !!this.refsTargets?.timed_out
        },
        // применённое бэкендом ограничение моделью (его подписи — из ответа): пусто — ограничения нет (не просили, GUID, старый бэкенд)
        refsScopeInfo() {
            if (this.activeCommand !== 'globalRefs' || this.refsUnsupported || this.refsPicking || this.answerCommand !== 'globalRefs') return null
            const info = (this.answer?.target_segments || [])[0]
            return info && typeof info === 'object' ? info : null
        },
        refsCollections() {
            if (this.activeCommand !== 'globalRefs' || this.refsUnsupported) return []
            if (this.answerCommand && this.answerCommand !== this.activeCommand) return []
            return this.answer?.refs_collections || []
        },
        // Отставание графа от данных. Два сигнала РАЗНЫЕ и текст у них разный:
        // graph_complete — прогон не довёл сборку до конца; graph_lag — сборка
        // прошла, но данные с тех пор ушли вперёд (на базе с пересчётом это
        // норма, а не сбой).
        // Чего база не умеет в полнотекстовом поиске. Показываем только на вкладке
        // «Текст» и только при пустой выдаче: это объяснение пустоты, а не украшение.
        searchCapsText() {
            // IE 2026 09 23 / ODOO-341407: i18n
            if (this.activeCommand !== 'globalSearch' || !this.CHIPS.length) return ''
            const caps = this.answer?.search_caps
            if (!caps) return ''
            if (caps.substring !== false && caps.has_title !== false) return ''
            // Сводные флаги значат «умеют ВСЕ коллекции», поэтому называем поимённо
            // те, где не умеет: иначе «на этой базе не работает» — преувеличение,
            // когда по записям поиск идёт, а по инбаунду нет.
            const rows = caps.by_collection || []
            const noSub = rows.filter(row => row.substring === false).map(row => row.collection)
            const noTitle = rows.filter(row => row.has_title === false).map(row => row.collection)
            if (!rows.length) {
                // Бэкенд без by_collection (ODOO-5052 выкачен, ODOO-4334 ещё нет):
                // сводный флаг значит «умеют НЕ ВСЕ», а какие именно — неизвестно.
                // Поэтому мягче: «не по всем коллекциям», а не «на этой базе».
                return this.t('Partial word or id search does not work for all collections of this database — some data is searched by whole words only')
            }
            const parts = []
            if (noSub.length) parts.push(this.t('by partial word or id — {collections} (no trgm indexes)', { collections: noSub.join(', ') }))
            if (noTitle.length) parts.push(this.t('by title — {collections} (the column is not in the index)', { collections: noTitle.join(', ') }))
            if (!parts.length) return ''
            return this.t('Search does not work for all collections: {parts}', { parts: parts.join('; ') })
        },
        refsLagText() {
            if (this.activeCommand !== 'globalRefs') return ''
            const lag = this.answer?.graph_lag || []
            if (!lag.length) return ''
            const parts = lag.map(row => `${row.collection} — ${this.store.formatCount(row.behind)}`)
            return this.t('The graph is behind the data — changed since the last build: {parts}', { parts: parts.join(', ') })   // IE 2026 09 23 / ODOO-341407: i18n
        },
        displayData() {
            if (this.command === 'globalHistory') {
                const ws = this.store.activeWORKSPACE?.workspace
                const pg = this.store.activeWORKSPACE?.active_page
                return this.store.frontHistory
                    .filter(e => e._workspace === ws && e._page === pg)
                    .sort((a, b) => (b.viewed_at || '').localeCompare(a.viewed_at || ''))
            }
            // ODOO-4334: строки прошлой вкладки не рисуем. Форма переживает hide/show
            // с прежним answer, а ветки шаблона разной формы: ребро без _meta,
            // отрисованное веткой полнотекстового поиска, роняет рендер целиком.
            if (this.answerCommand && this.answerCommand !== this.activeCommand) return []
            // на неподдерживающей базе строк не рисуем вовсе: половина полей пуста,
            // а клик по строке всё равно ничего не откроет
            if (this.activeCommand === 'globalRefs' && this.refsUnsupported) return []
            return this.answer?.data || []
        },
        computedPosition() {
            const position = this.position
            return { top: position.top + 'px', left: position.left + 'px', width: position.width + 'px' }
        },
        formattedText() {
            // IE 2026 09 23 / ODOO-341407: i18n
            let textMore = this.t('Search more...')

            if (this.activeCommand === 'globalRefs') {
                if (this.refsTimedOut) return ''   // webscm 2026 10 25 / ODOO-4334 (шаг 1): защита — на timed_out #466 списка не шлёт; придёт — частичный, число было бы ложью
                if (this.refsPicking) return this.t('Models with this id: {n}', { n: this.refsTargets.targets.length })   // webscm 2026 10 25 / ODOO-4334 (шаг 1)
                const n = this.displayData.length
                return n ? this.t('Fields referring to this id: {n}', { n }) : ''
            }
            if (this.command === 'globalHistory') {
                textMore = this.t('View more activities...')
            } else if (this.command === 'globalJob') {
                textMore = this.t('Ask job...')
            } else if (this.command === 'globalLog') {
                textMore = this.t('Log more...')
            }

            const count = this.answer?.data_count
            return `${textMore} ${this.tn(count ?? 0, '{n} record', '{n} records', { n: this.store.formatCount(count) })}`
        },
    }
}
</script>

<style scoped>
.globalSearch {
    position: absolute;
    z-index: 1000;
    background: white;
    border: 3px solid rgba(255,150,30,.75);
    border-radius: 0.5rem;
    list-style: none;
    padding: 0;
    margin: 0;

    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 40px);

    box-shadow: 0 1px 2px rgba(55, 63, 66, 0.07), 0 2px 4px rgba(55, 63, 66, 0.07), 0 4px 8px rgba(55, 63, 66, 0.07), 0 8px 16px rgba(55, 63, 66, 0.07), 0 16px 24px rgba(55, 63, 66, 0.07), 0 24px 32px rgba(55, 63, 66, 0.07);
}
.globalSearch .search-comment {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
}
/* ODOO-4334 */
.globalSearch .search-tabs {
    display: flex;
    flex-direction: row;
    gap: 4px;
    padding: 0.5rem 0.5rem 0;
}
.globalSearch .search-tab {
    background: #f5f5f5;
    border: 1px solid #ddd;
    border-bottom: none;
    border-radius: 6px 6px 0 0;
    padding: 4px 12px;
    cursor: pointer;
    font-size: 0.85rem;
    color: #666;
}
.globalSearch .search-tab--active {
    background: #fff;
    color: #333;
    font-weight: 600;
    border-color: rgba(255,150,30,.75);
}
.globalSearch .search-empty {
    padding: 15px;
    color: #888;
    font-style: italic;
}
.globalSearch .search-empty--unsupported {
    color: #b34700;
    font-style: normal;
}
.refs-count {
    font-weight: 600;
    margin-right: 6px;
}
.external-search--static {
    cursor: default;
}
.refs-tree .refs-incomplete {
    padding: 6px 10px;
    color: #b34700;
    font-size: 0.9rem;
}
/* webscm 2026 10 25 / ODOO-4334 (шаг 1): чипс модели цели и список «на какую модель?» */
.refs-scope .search-item {
    display: flex;
    align-items: baseline;
    gap: 4px;
    padding: 4px 10px;
}
.refs-scope .refs-scope-clear {
    font-size: 0.8rem;
    opacity: 0.6;
    margin-left: 4px;
}
.refs-targets .refs-targets-head {
    padding: 8px 10px 4px;
    color: #555;
}
.refs-targets .search-item {
    display: flex;
    align-items: baseline;
    gap: 4px;
    padding: 4px 10px;
}
.refs-targets .meta-chip {
    font-size: 1rem;
}
.refs-targets .refs-targets-all {
    font-style: italic;
    color: #666;
}
/* ODOO-4334: иерархия «вид объекта → поле → примеры» */
.refs-tree .refs-group {
    padding: 6px 10px;
    border-bottom: 1px solid var(--surface-border, #e5e7eb);
}
.refs-tree .refs-group-head {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
}
.refs-tree .refs-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 4px;
}
/* поле — это ЧИПС уточнения, а не заголовок: общий .meta-chip задан под крупные
   плашки сегмента (1.3rem bold), внутри дерева он подавляет собой примеры */
.refs-tree .refs-fields .meta-chip {
    margin-left: 0;
    font-size: 0.95rem;
    background: var(--surface-100, #f1f5f9);
    border: 1px solid var(--surface-border, #e5e7eb);
}
.refs-tree .refs-fields .meta-chip b {
    margin-left: 4px;
}
.refs-tree .refs-fields .meta-chip i {
    font-style: normal;
    opacity: 0.7;
}
.refs-tree .refs-samples .search-title {
    font-size: 1rem;
    padding: 0;
}
/* кликабельность чипса-уточнения видна: у декоративного чипса курсор обычный */
.refs-tree .refs-chip {
    cursor: pointer;
}
.refs-tree .refs-chip:hover {
    text-decoration: underline;
}
.refs-tree .refs-samples {
    margin: 0;
    padding: 0;
    list-style: none;
}
.refs-tree .refs-samples li {
    padding: 2px 0 2px 12px;
    display: flex;
    gap: 8px;
    align-items: baseline;
}
.refs-tree .refs-more {
    padding: 2px 0 0 12px;
    font-size: 0.85em;
    cursor: pointer;
    opacity: 0.75;
}
.refs-tree .refs-more:hover {
    opacity: 1;
    text-decoration: underline;
}
.globalSearch .search-input {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
}
.search-results {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    margin-top: 10px;
    max-height: calc(100vh - 150px);
}
.search-results ul {
    list-style: none;
    padding: 0;
    margin: 0;
}
.search-item {
    padding: 10px;
    cursor: pointer;
    transition: background 0.2s;
    border-bottom: 1px solid #eee;
    border-left: 3px solid transparent;
}
.search-item--open {
    border-left-color: #66bb6a;
    background: rgba(102, 187, 106, 0.04);
}
.history-checker {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    cursor: pointer;
    accent-color: #66bb6a;
}
.history-checker:disabled {
    cursor: not-allowed;
    opacity: 0.4;
}
  
.search-item:hover {
    background: #f5f5f5;
}
.meta {
    font-size: 12px;
    margin-left: 8px;
    padding: 2px 5px;
    border-radius: 3px;
}
.meta-chip {
    margin-left: 8px;
    padding: 2px 5px;
    border-radius: 3px;

    font-stretch: ultra-condensed;
    font-size: 1.3rem;
    font-weight: bold;
}
.value {
    font-stretch: ultra-condensed;
}

.search-id {
    font-weight: lighter;
}
.search-title {
    font-size: large;
    padding: 5px;
}
.external-search {
    background: #f5f5f5;
    cursor: pointer;
    padding: 15px;
}
.external-search--action {
    display: flex;
    align-items: center;
    gap: 8px;
}
.external-search--action:hover {
    background: #ece9e4;
}
.hotkey-badge {
    margin-left: auto;
    background: #e0e0e0;
    border: 1px solid #bbb;
    border-radius: 4px;
    padding: 1px 6px;
    font-size: 11px;
    font-family: inherit;
    color: #555;
    box-shadow: 0 1px 0 #bbb;
    white-space: nowrap;
}
.search-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
}
.search-content--row {
    flex-direction: row;
    align-items: center;
    gap: 6px;
}
.widget-mini-badge {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.1rem;
    padding: 1px 4px;
    flex-shrink: 0;
}
.search-content--row .search-title {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0;
}
.search-content--row .order-number {
    flex-shrink: 0;
}
.widget-mini-btns {
    display: flex;
    gap: 2px;
    flex-shrink: 0;
}
.widget-mini-btns .meta {
    margin-left: 0;
    padding: 2px 4px;
}
.search-info {
    display: flex;
}
.search-collections {
    display: flex;
    flex-wrap: wrap;
}
/* IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): ряд фасетов — чипсы-переключатели (общий .toggle-chip), отступы как у ряда компаний в выборе баз */
.search-facets {
    gap: 0.15rem;
    padding: 6px 10px;
}
.search-facets:empty {
    padding: 0;
}
/* IE 2026 10 28 / ODOO-5800 (заказ Игоря: фасеты таблиц глобального поиска — на месте, как чипсы баз): длинный титул сегмента переносится внутри чипса,
   как у прежнего meta-chip — иначе чипс 700–800 px вылезает за правый край панели поиска поверх грида (smoke webscm #112031, Demo8 PS-INV103211) */
.search-facets .toggle-chip {
    white-space: normal;
    overflow-wrap: anywhere;
    max-width: 100%;
    box-sizing: border-box;
}
.job-comment {
    width: 100%;
    min-height: 100px;
    padding: 10px;
    border: 1px solid #ccc;
    background: lightgoldenrodyellow;
    font-size: 16px;
    outline: none;
}
.job-comment:focus {
    border: 1.5px solid #ccc;
}
</style>